// import React from 'react';
// import Wrp from '../../../hoc/Wrp/Wrp';
import { setAndGetAttributes } from '../../FormInputFields/FormInputFunctions';
import { isSet } from '../../../Utils/CommonFunctions';

export const formFieldsAttributes = (item,validationForms)=>{
    let classNames = [item.className];
    // const checkClassNames = (item.required===true || item.isMandatory===true)? (item.hideMandatory)?'':classNames.push('mandatory'):'';
    if(item.required===true || item.isMandatory===true){
        if(item.hideMandatory){
        }else{
          classNames.push('mandatory')
        }
    }
    // Input field attributes. Prefer explicit placeholder (Pages scm:inputtext
    // placeholder="…") over layout helpText gated by isPlaceHolder.
    const explicitPlaceholder =
      item.placeholder ??
      item.placeHolder ??
      (item.attributes && (item.attributes.placeholder || item.attributes.placeHolder));
    const layoutPlaceholder =
      item.isPlaceHolder == true || item.isPlaceHolder === "true"
        ? item.helpText
        : "";
    let fieldAttributes = {
      ...setAndGetAttributes(item),
      placeholder:
        explicitPlaceholder != null && String(explicitPlaceholder).trim() !== ""
          ? explicitPlaceholder
          : layoutPlaceholder || "",
      className: classNames.join(' '),
      readOnly:(item.access_mode=='VIEWONLY')?true:false,
      id:isSet(item.attrFieldId,null)!==null?isSet(item.attrFieldId,null):(item.id!=='')? item.id:'',
    };
    let itemMax = item.attributes!==undefined ? item.attributes.maxLength : item.max;
    if(item.field_type === 'Percentage') {  // For import Page
      if(item.decimal_places === 0){
        itemMax=parseInt(itemMax);
      }else {
        itemMax=parseInt(itemMax)+1;
      } 
      if(item.selectedValue && item.selectedValue.includes('.')){
        itemMax = parseInt(itemMax)+parseInt(item.decimal);
      }
    }
    if(item.element === 'Percentage' || item.type === 'Percentage'){
      if(item.decimal === 0){
        itemMax=parseInt(itemMax);
      }else {
        itemMax=parseInt(itemMax)+1;
      }if(item.selectedValue && item.selectedValue.includes('.')){
        itemMax = parseInt(itemMax)+parseInt(item.decimal);
      }
    }
    if(item.otherDetials!==undefined){  // For Filter Percentage
      itemMax = item.otherDetials.max;
      if(item.otherDetials.field_type === 'Percentage') {  
        if(item.otherDetials.decimal_places === 0){
          itemMax=parseInt(item.otherDetials.max);
        }
        else{
          itemMax=parseInt(item.otherDetials.max)+1;
        }
        if(item.field_value && item.field_value.includes('.')) {
          itemMax = parseInt(itemMax)+parseInt(item.otherDetials.decimal_places);
        }
      }
    }
    if(item.element === 'Currency'){
      if(item.default_value && item.default_value.includes('.')) {
        itemMax = parseInt(itemMax)+1;
      }
    }
    
    if(item.element === 'Percentage' || item.type === 'Percentage' || item.type === 'Decimal'){
      if(item.decimal === 0 || item.decimal_places === "0" || (item.attributes && item.attributes.decimal === 0)){
        itemMax=parseInt(itemMax);
      }else {
        itemMax=parseInt(itemMax)+1;
      }
      if(item.selectedValue && item.selectedValue.toString().includes('.') || item.value && item.value.toString().includes('.') || item.value && item.value.toString().includes('-')){
        itemMax = parseInt(itemMax)+parseInt(item.decimal);
      }
    }
   
    //Check for max length
    const CHAR_LIMIT_FIELDS = ['Phone','TextInput','TextArea','PostalCode'];
    fieldAttributes = (isSet(itemMax,null)!==null)?{...fieldAttributes,maxLength:itemMax,max:itemMax}:{...fieldAttributes};
    if(CHAR_LIMIT_FIELDS.indexOf(item.element)!==-1){
      fieldAttributes = (isSet(item.charLimit,null)!==null)?{...fieldAttributes,maxLength:item.charLimit}:{...fieldAttributes};  
    }
    if(isSet(item.decimal,null)!==null){
      fieldAttributes={
        ...fieldAttributes,
        decimal:item.decimal
      }
    }
    const returnData = {
      formGroupCss:{
        display:(item.access_mode==='HIDDEN')?'none':''
      },
      fieldAttributes:{...fieldAttributes},
      value:(isSet(item.selectedValue,null)!==null || item.overridden)?item.selectedValue:(isSet(item.default_value,null)!==null)?'':'',//item.default_value
      validation:{
        hasErrorClass:(validationForms &&  validationForms[item.id] && validationForms[item.id]!='')? 'has-error':'',
        message:(validationForms && validationForms[item.id] && validationForms[item.id]!='')? validationForms[item.id]:''
      },  
      // onChange:(item.onChangeHandler)?item.onChangeHandler:onChangeHandler
    }
    return returnData;
  }  

  export const getUpdateDataProps = (param)=>{
    const {section,subformObj,item}= param.propsObj;
    const updateData = {
      section_index:section.section_index,
      itemIndex:item.itemIndex,
      item:item,
      ...subformObj
    }
    return updateData;
  }

  //CHECK THE VARIABLE IS EXISTS AND NOT EQUAL TO EMPTY
  const IsExists = (item)=>{
    return (item && item!=='' && item!==null)?true:false;
  }

  export const bytesToSize = (bytes)=>{
    var sizes = ['B', 'KB', 'MB', 'GB', 'TB'];
   if (bytes == 0) return '0 B';
   var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
   return Math.round(bytes / Math.pow(1024, i), 2) + ' ' + sizes[i];
  }